import HttpRequest from '@/api/axios';

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);
import moment from 'moment';

export default {
    vote(params) {
        return axios.request({
            url: `sports-item-user/vote`,
            method: 'post',
            data: params,
            baseURL: process.env.VUE_APP_API_BASE_URL2,
        });
    },
    getVoteDetail(id) {
        return axios.request({
            url: `sports-item-user/${id}?expand=sportsItem,sportsItemSub,userInfo`,
            method: 'get',
            baseURL: process.env.VUE_APP_API_BASE_URL2,
        });
    },
    sportsMain(id) {
        return axios.request({
            url: `sports/${id}?expand=items`,
            method: 'get',
            baseURL: process.env.VUE_APP_API_BASE_URL2,
        });
    },
    getItemSubs: function (data) {
        return axios
            .request({
                url: `mwap/compareinfo`,
                method: 'get',
                params: data,
            })
            .then((res) => {
                if (+res.status === 200) {
                    let sys_time = res.sys_time;
                    let {list} = res.data;
                    res.data.canjoin = '';
                    list.forEach((item) => {

                        item.start_time_show = moment(item.start_time * 1000).format(
                            'MM月DD日 HH:mm'
                        );
                        item.end_time_show = moment(item.end_time * 1000).format(
                            'MM月DD日 HH:mm'
                        );
                        item.start_time_week = moment(item.start_time * 1000).format(
                            'dd'
                        );
                        item.start_time_day = moment(item.start_time * 1000).format(
                            'DD'
                        );
                        if (!item.attended && sys_time >= item.start_time * 1 && sys_time <= item.end_time * 1) {
                            res.data.canjoin = item;
                        }
                        if(sys_time < item.start_time){
                            item.state_title = '未开始'
                            item.state = 0;
                        }else if(sys_time > item.end_time){
                            item.state_title = '已结束'
                            item.state= 2;
                        }else{
                            item.state_title = '进行中'
                            item.state=1;
                        }

                    });
                }
                return res;
            });
    },
    getItemSubst: function (data) {
        return axios
            .request({
                url: `mwap/compareinfotmp`,
                method: 'get',
                params: data,
            })
            .then((res) => {
                if (+res.status === 200) {
                    let sys_time = res.sys_time;
                    let {list} = res.data;
                    res.data.canjoin = '';
                    list.forEach((item) => {

                        item.start_time_show = moment(item.start_time * 1000).format(
                            'MM月DD日 HH:mm'
                        );
                        item.end_time_show = moment(item.end_time * 1000).format(
                            'MM月DD日 HH:mm'
                        );
                        item.start_time_week = moment(item.start_time * 1000).format(
                            'dd'
                        );
                        item.start_time_day = moment(item.start_time * 1000).format(
                            'DD'
                        );
                        if (!item.attended && sys_time >= item.start_time * 1 && sys_time <= item.end_time * 1) {
                            res.data.canjoin = item;
                        }
                        if(sys_time < item.start_time){
                            item.state_title = '未开始'
                            item.state = 0;
                        }else if(sys_time > item.end_time){
                            item.state_title = '已结束'
                            item.state= 2;
                        }else{
                            item.state_title = '进行中'
                            item.state=1;
                        }

                    });
                }
                return res;
            });
    },
    getComparegame: function (data) {
        return axios
            .request({
                url: `mwap/comparegame`,
                method: 'post',
                data,
            })
            .then((r) => {
                return r;
            });
    },
    submitCompare(data) {
        return axios.request({
            url: 'mwap/submitcompare',
            method: 'post',
            data,
        });
    },
    submitStp(data) {
        return axios.request({
            url: 'mwap/submitcomparetmp',
            method: 'post',
            data,
        });
    },
    compareRank(params) {
        return axios.request({
            url: 'mwap/comparerank',
            method: 'get',
            params,
        });
    },
    questionRank(params) {
        return axios.request({
            url: 'mwap/question-rank',
            method: 'get',
            params,
        });
    },
    compareRank2(params) {
        return axios.request({
            url: 'mwap/comparerank2',
            method: 'get',
            params,
        });
    },
    compareRankAll(params) {
        return axios.request({
            url: 'mwap/compare-rank-all',
            method: 'get',
            params,
        });
    },
    compareRankMaxAll(params) {
        return axios.request({
            url: 'mwap/compare-rank-max-all',
            method: 'get',
            params,
        });
    },
    winrateRank(params) {
        return axios.request({
            url: 'mwap/winrate-rank',
            method: 'get',
            params,
        });
    },
    compareSub(params) {
        return axios.request({
            url: 'mwap/sublist',
            method: 'get',
            params,
        });
    },
    myRanks(params) {
        return axios.request({
            url: 'mwap/my-attend',
            method: 'get',
            params,
        });
    },
    myList(params) {
        return axios.request({
            url: 'sports/sports-item-user',
            method: 'get',
            params,
        });
    },
    // sports-item/rank?id=8&token=ffgov3ox5wkg52kr
    getSportsItemRank(params) {
        return axios.request({
            url: 'sports-item/rank',
            method: 'get',
            params,
            baseURL: process.env.VUE_APP_API_BASE_URL2,
        });
    },
    // sports-item/rank?id=8&token=ffgov3ox5wkg52kr
    getMySportsItemRank(params) {
        return axios.request({
            url: 'sports-item/my-rank',
            method: 'get',
            params,
            baseURL: process.env.VUE_APP_API_BASE_URL2,
        });
    },
    getFormConfig(params) {
        return axios.request({
            url: 'forms/detail',
            method: 'get',
            params,
        });
    },
    submitFormData(params) {
        return axios.request({
            url: 'forms/save',
            method: 'get',
            params,
        });
    },
    getItemList(params) {
        return axios.request({
            url: 'sports/item-list',
            method: 'get',
            params,
        });
    },
    getTastList(params) {
        return axios.request({
            url: 'sports/sports-task',
            method: 'get',
            params
        });
    },
    getTastInfo(params) {
        return axios.request({
            url: 'sports/sports-task-info',
            method: 'get',
            params
        });
    },
    getTastStatus(params) {
        return axios.request({
            url: 'sports/task-status',
            method: 'get',
            params
        });
    },
    getTastAction(params) {
        return axios.request({
            url: 'sports/task-action',
            method: 'get',
            params
        });
    },
    getComments(params) {
        return axios.request({
            url: 'sports-comment/list',
            method: 'get',
            params,
            baseURL: process.env.VUE_APP_API_BASE_URL2,
        });
    },
    submitComment(params) {
        return axios.request({
            url: 'sports-comment/create',
            method: 'post',
            data: params,
            baseURL: process.env.VUE_APP_API_BASE_URL2,
        });
    },
    registerSports(params) {
        return axios.request({
            url: `sports/register`,
            method: 'post',
            data: params,
            baseURL: process.env.VUE_APP_API_BASE_URL2,
        });
    },
    pointsRank(id, data) {
        return axios.request({
            url: `sports/${id}/points-rank`,
            method: 'get',
            params: data,
            baseURL: process.env.VUE_APP_API_BASE_URL2,
        });
    },
};
